import axios from "axios";
import { createToaster } from "@meforma/vue-toaster";
import router from "./router";

const toaster = createToaster({
  position: "top-right",
  dismissible: true,
  duration: 3000,
});

const $axios = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    Authorization: "Bearer " + localStorage.getItem("token"),
  },
  timeout: 30000,
});

$axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (!navigator.onLine) {
      toaster.error("Status Offline");
      return;
    }

    if (!error.response) {
      toaster.error("Request Timeout");
      return;
    }

    if (error.response.status == 422) {
      var errors = error.response.data.errors
        ? error.response.data.errors
        : error.response.data;
      for (var key in errors) {
        var validation_error = errors[key];
        for (var message in validation_error) {
          toaster.error(validation_error[message]);
        }
      }
    } else if (error.response.status == 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      toaster.error(
        error.response.data.message +
          "<br> Anda Tidak Bisa Mengakses/Melakukan Aksi di  Halaman Ini"
      );

      delete $axios.defaults.headers.Authorization;
      router.push("/login");
      setTimeout(function () {
        // window.location.reload();
      }, 1500);
    } else if (error.response.status == 403) {
      toaster.error(
        error.response.data.message +
          "<br> Anda Tidak Bisa Mengakses/Melakukan Aksi di  Halaman Ini"
      );

      if (error.response.data.survey) {
        let survey = error.response.data.survey;
        router.push("/survey/" + survey.id);
      } else {
        router.push("/profile");
      }
      setTimeout(function () {
        // window.location.reload();
      }, 1500);
    }
  }
);
export default $axios;
